import { crv, css, cva } from '@/styled-system/css';

export const iconRecipe = cva({
  base: {
    display: 'inline-flex',
    flexShrink: '0',
    verticalAlign: '-0.125em', // Magic number, but works with all textStyles
    fill: 'currentcolor',
    width: '1em',
    height: '1em',
  },
  variants: {
    ...crv('size', {
      sm: { '&': { width: 'icon.sm', height: 'icon.sm' } },
      md: { '&': { width: 'icon.md', height: 'icon.md' } },
      lg: { '&': { width: 'icon.lg', height: 'icon.lg' } },
      xl: { '&': { width: 'icon.xl', height: 'icon.xl' } },
    }),
  },
});

export const topAgentIconStyles = css.raw({
  '& > .c11n-top-agent-accent-fixed': {
    fill: 'Icon.TopAgent.accent-fixed',
  },
  '& > .c11n-top-agent-brand-fixed': {
    fill: 'Icon.TopAgent.brand-fixed',
  },
  '& > .c11n-top-agent-brand-alt-fixed': {
    fill: 'Icon.TopAgent.brand-alt-fixed',
  },
  '& > .c11n-top-agent-white-fixed': {
    fill: 'Icon.TopAgent.white-fixed',
  },
});
